import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Download, Clock, MapPin } from 'lucide-react';
import { ScrollButton } from './ui/ScrollButton';
export const HeroSection = () => {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative overflow-hidden pt-20 pb-8 sm:pt-40 sm:pb-24 bg-cream" data-id="element-154">
      <div className="container relative mx-auto px-4" data-id="element-155">
        <div className="mx-auto max-w-4xl text-center" data-id="element-156">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="mb-3 sm:mb-6 inline-flex items-center gap-2 rounded-full border border-brand-200 bg-brand-50 px-3 py-1 sm:px-4 sm:py-1.5 text-xs sm:text-sm font-semibold text-brand-700" data-id="element-157">
            <span className="relative flex h-2 w-2" data-id="element-158">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-brand-400 opacity-75" data-id="element-159"></span>
              <span className="relative inline-flex h-2 w-2 rounded-full bg-brand-500" data-id="element-160"></span>
            </span>
            ⚠️ PARA PROFESIONALES INDEPENDIENTES EN ARGENTINA — 2026
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="mb-3 sm:mb-6 tracking-tight text-[36px] sm:text-6xl lg:text-7xl text-balance text-neutral-900 font-[600] font-[Merriweather,_serif]" data-id="element-161">
            Argentina 2026: El mercado cambió.
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="mx-auto mb-5 sm:mb-10 max-w-2xl text-base sm:text-xl text-neutral-600 text-balance" data-id="element-162">
            Si tu WhatsApp lleva días sin sonar, si mandaste presupuestos y
            nadie respondió, si tus clientes te dicen "dejame pensarlo" y
            desaparecen...{' '}
            <strong className="text-neutral-900 font-semibold" data-id="element-163">
              esto es exactamente para vos.
            </strong>
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3
        }} className="mb-6 sm:mb-12 flex justify-center" data-id="element-164">
            {/* Book Cover */}
            <div onClick={scrollToCompra} className="relative cursor-pointer transition-transform hover:scale-[1.02] group" style={{
            perspective: '1200px'
          }} data-id="element-165">
              {/* Book shadow */}
              <div className="absolute -bottom-3 sm:-bottom-4 left-4 right-4 h-6 sm:h-8 bg-neutral-900/10 blur-xl rounded-full" data-id="element-166" />

              {/* Book spine effect */}
              <div className="absolute left-0 top-0 bottom-0 w-3 sm:w-4 bg-brand-800 rounded-l-md z-10 shadow-inner" data-id="element-167" />

              {/* Main cover */}
              <div className="relative w-[180px] sm:w-[320px] md:w-[420px] aspect-[3/4] bg-gradient-to-br from-brand-700 via-brand-600 to-brand-700 rounded-r-lg rounded-l-sm shadow-2xl overflow-hidden ml-1" data-id="element-168">
                {/* Subtle texture overlay */}
                <div className="absolute inset-0 opacity-[0.04]" style={{
                backgroundImage: "url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")"
              }} data-id="element-169" />

                {/* Top decorative line */}
                <div className="absolute top-0 left-0 right-0 h-1 bg-brand-300/40" data-id="element-170" />

                {/* Content */}
                <div className="relative z-10 flex flex-col items-center justify-between h-full px-4 sm:px-12 py-5 sm:py-14 text-center" data-id="element-171">
                  {/* Top section */}
                  <div className="space-y-2 sm:space-y-4" data-id="element-172">
                    <div className="w-10 sm:w-16 h-px bg-brand-300/50 mx-auto" data-id="element-173" />
                    <p className="text-brand-200/80 text-[8px] sm:text-sm font-sans uppercase tracking-[0.3em] font-medium" data-id="element-174">
                      Manual Táctico · Argentina 2026
                    </p>
                    <div className="w-10 sm:w-16 h-px bg-brand-300/50 mx-auto" data-id="element-175" />
                  </div>

                  {/* Center — Title */}
                  <div className="space-y-3 sm:space-y-6 flex-1 flex flex-col items-center justify-center" data-id="element-176">
                    <h2 className="text-3xl sm:text-6xl md:text-7xl font-bold text-white leading-[0.9] tracking-tight" style={{
                    fontFamily: 'Merriweather, serif'
                  }} data-id="element-177">
                      CAJA
                      <br data-id="element-178" />
                      <span className="text-brand-200" data-id="element-179">DE</span>
                      <br data-id="element-180" />
                      COBRO
                    </h2>

                    {/* Decorative divider */}
                    <div className="flex items-center gap-2 sm:gap-3" data-id="element-181">
                      <div className="w-5 sm:w-8 h-px bg-brand-300/60" data-id="element-182" />
                      <div className="w-1.5 h-1.5 sm:w-2 sm:h-2 rotate-45 border border-brand-300/60" data-id="element-183" />
                      <div className="w-5 sm:w-8 h-px bg-brand-300/60" data-id="element-184" />
                    </div>

                    {/* Slogan */}
                    <p className="text-brand-100 text-sm sm:text-xl italic font-display tracking-wide" data-id="element-185">
                      "El Mercado Cambió"
                    </p>
                  </div>

                  {/* Bottom section */}
                  <div className="space-y-2 sm:space-y-3" data-id="element-186">
                    <div className="w-16 sm:w-24 h-px bg-brand-300/40 mx-auto" data-id="element-187" />
                    <p className="text-brand-300/70 text-[7px] sm:text-xs font-sans uppercase tracking-[0.25em]" data-id="element-188">
                      Sistema de Ventas para Profesionales
                    </p>
                  </div>
                </div>

                {/* Bottom decorative line */}
                <div className="absolute bottom-0 left-0 right-0 h-1 bg-brand-300/40" data-id="element-189" />

                {/* Subtle light reflection */}
                <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-white/[0.06] to-transparent pointer-events-none" data-id="element-190" />
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4
        }} className="mx-auto max-w-3xl rounded-xl border border-neutral-200 bg-white p-4 sm:p-8 shadow-sm" data-id="element-191">
            <p className="mb-4 sm:mb-8 text-base sm:text-xl font-medium text-neutral-700" data-id="element-192">
              El manual táctico que te muestra, con palabras exactas y paso a
              paso, cómo reactivar clientes, cerrar presupuestos y cobrar en el
              contexto más difícil de los últimos años.
            </p>

            <ScrollButton className="w-full sm:w-auto sm:px-12 sm:py-5 sm:text-xl mb-4 sm:mb-6" data-id="element-193">
              👇 QUIERO MI CAJA DE COBRO AHORA
            </ScrollButton>

            <div className="flex flex-wrap items-center justify-center gap-x-4 sm:gap-x-6 gap-y-2 sm:gap-y-3 text-xs sm:text-sm font-medium text-neutral-500" data-id="element-194">
              <span className="flex items-center gap-1.5" data-id="element-195">
                <Clock className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-brand-600" data-id="element-196" />{' '}
                Acceso inmediato
              </span>
              <span className="flex items-center gap-1.5" data-id="element-197">
                <Download className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-brand-600" data-id="element-198" />{' '}
                Descarga instantánea
              </span>
              <span className="flex items-center gap-1.5" data-id="element-199">
                <ShieldCheck className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-brand-600" data-id="element-200" />{' '}
                Garantía 7 días
              </span>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.6
        }} className="mt-6 sm:mt-12 flex flex-wrap items-center justify-center gap-3 sm:gap-8 text-[10px] sm:text-xs font-semibold tracking-wider text-neutral-400 uppercase" data-id="element-201">
            <span className="flex items-center gap-1 sm:gap-2" data-id="element-202">
              🔒 Pago 100% seguro
            </span>
            <span className="flex items-center gap-1 sm:gap-2" data-id="element-203">
              📥 Descarga inmediata
            </span>
            <span className="flex items-center gap-1 sm:gap-2" data-id="element-204">
              ✅ Garantía 7 días
            </span>
            <span className="flex items-center gap-1 sm:gap-2" data-id="element-205">
              🇦🇷 Hecho para Argentina
            </span>
          </motion.div>
        </div>
      </div>
    </section>;
};